module.exports = __webpack_public_path__ + "media/images/line_chart_secodary_axis-61a67c614e8fcb199a1bc48646e1431a.png";